import { Controller } from "@hotwired/stimulus"

// Toggles dark mode and persists the choice.
//
// The initial `.dark` class is set by the no-FOUC inline script in
// `application.html.erb` <head> (so first paint is already correct). This
// controller only handles user-initiated toggling from the navbar button.
//
// Persistence is layered:
//   - localStorage (instant, per-browser, no FOUC on next load)
//   - server (`user_profiles.preferences["theme"]`, via the `theme-preference`
//     meta endpoint rendered only when signed in) so the choice follows the
//     user across browsers/devices.
//
// Icons are handled purely in CSS (`dark:hidden` / `hidden dark:block`) so
// there is no per-toggle DOM work here.
export default class extends Controller {
  toggle() {
    const root = document.documentElement
    const isDark = root.classList.toggle("dark")
    const theme = isDark ? "dark" : "light"

    try {
      localStorage.setItem("theme", theme)
    } catch (e) {
      // localStorage may be unavailable (private mode, etc.) — fall back to
      // the session-only class toggle.
    }

    this.persistToServer(theme)
  }

  // Fire-and-forget PATCH to the settings#update_profile endpoint (the same
  // one the PARA-threshold form uses). Silently skips when the user is a guest
  // (no meta tag) or the request fails — the localStorage value still wins for
  // the current browser.
  persistToServer(theme) {
    const url = this.serverUrl()
    if (!url) return

    const token = this.csrfToken()
    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        ...(token ? { "X-CSRF-Token": token } : {})
      },
      body: JSON.stringify({ profile: { theme: theme } }),
      credentials: "same-origin"
    }).catch(function () { /* ignore — preference stays local */ })
  }

  serverUrl() {
    const meta = document.querySelector("meta[name='theme-preference-url']")
    return meta ? meta.content : null
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : null
  }
}
